import {
  Route,
  Routes,
} from 'react-router-dom';

import { loginRoutes } from '../../routes';

const AccountManagement = () => (
  <div className="account-dashboard">
    <Routes>
      {loginRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          exact
          element={route.main}
        />
      ))}
    </Routes>
  </div>
);

export default AccountManagement;
